import {
  FETCH_CUSTODIANS_REQUEST,
  FETCH_CUSTODIANS_SUCCESS,
  FETCH_CUSTODIANS_FAILURE,
  UPDATE_CUSTODIANS_REQUEST,
  UPDATE_CUSTODIANS_FAILURE,
  ADD_NEW_CUSTODIAN,
  DELETE_CUSTODIAN,
  SEARCH_CUSTODIANS_FAILURE,
  SEARCH_CUSTODIANS_REQUEST,
  SEARCH_CUSTODIANS_SUCCESS,
  ADD_CUSTODIAN_DATA,
  CUSTODIAN_DETAILS_LOADING,
  CUSTODIAN_DETAILS_FAILURE
} from 'store/types/favouriteCustodians';
import { ThunkAction } from 'redux-thunk';
import { Custodian, FoundCustodian, SearchBy } from 'types';
import { State } from 'store/reducers/favouriteCustodians.reducer';
import { api2 } from '../apis'

export const requestCustodians = () => ({
  type: FETCH_CUSTODIANS_REQUEST,
});

export const failureRequest = (error: string) => ({
  type: FETCH_CUSTODIANS_FAILURE,
  error,
});

export const receiveCustodians = (data: Custodian[]) => ({
  type: FETCH_CUSTODIANS_SUCCESS,
  preload: data,
});

export const receiveCustodian = (data: Custodian) => ({
  type: ADD_NEW_CUSTODIAN,
  preload: data,
});

export const deleteLocalCustodian = (id: number) => ({
  type: DELETE_CUSTODIAN,
  id,
});

export const updateCastodians = () => ({
  type: UPDATE_CUSTODIANS_REQUEST,
});

export const failureUpdate = (error: string) => ({
  type: UPDATE_CUSTODIANS_FAILURE,
  error,
});

export const searchCustodiansRequest = () => ({
  type: SEARCH_CUSTODIANS_REQUEST,
});

export const receiveFoundCustodians = (data: FoundCustodian[], add?: boolean) => ({
  type: SEARCH_CUSTODIANS_SUCCESS,
  preload: data,
  add
});

export const searchCustodiansFailure = (error: string) => ({
  type: SEARCH_CUSTODIANS_FAILURE,
  error,
});

export const custodianDetailsLoading = () => ({
  type: CUSTODIAN_DETAILS_LOADING
})
export const custodianDetailsFailure = (error: string) => ({
  type: CUSTODIAN_DETAILS_FAILURE,
  error
})
export const addCustodian = (data: FoundCustodian) => ({
  type: ADD_CUSTODIAN_DATA,
  preload: data
})

export type Actions =
  | ReturnType<typeof searchCustodiansRequest>
  | ReturnType<typeof receiveFoundCustodians>
  | ReturnType<typeof searchCustodiansFailure>
  | ReturnType<typeof requestCustodians>
  | ReturnType<typeof failureRequest>
  | ReturnType<typeof receiveCustodians>
  | ReturnType<typeof receiveCustodian>
  | ReturnType<typeof deleteLocalCustodian>
  | ReturnType<typeof updateCastodians>
  | ReturnType<typeof failureUpdate>
  | ReturnType<typeof custodianDetailsLoading>
  | ReturnType<typeof custodianDetailsFailure>
  | ReturnType<typeof addCustodian>;

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export const custodiansFetch = (isFormRequest?: boolean): ThunkResult<void> => async dispatch => {
  dispatch(requestCustodians());
  api2
    .get(`/api/v2/user/get_favourite_custodians?is_form_request=${isFormRequest}`)(dispatch)
    .then(res => {
      dispatch(receiveCustodians(res.custodians));
    })
    .catch(error => dispatch(failureRequest(error)));
};

export const deleteCustodian = (id: number): ThunkResult<void> => async dispatch => {
  dispatch(updateCastodians());
  api2.delete('/api/v2/user/remove_favourite_custodians', { custodian_id: id })(dispatch)
    .then(res => {
      dispatch(deleteLocalCustodian(id));
    })
    .catch(error => dispatch(failureUpdate(error)));
};

export const addToFavourite = (id: number, isFormRequest?: boolean): ThunkResult<void> => async dispatch => {
  api2.post('/api/v2/user/add_favourite_custodians', { custodian_id: id })(dispatch)
    .then(res => {
      dispatch(custodiansFetch(isFormRequest))
    })
    .catch(error => dispatch(searchCustodiansFailure(error)));
};

export const searchCustodians = (searchBy: SearchBy, isFormRequest: boolean, add?: boolean, callback?: (data: any) => void): ThunkResult<void> => async dispatch => {
  !add && dispatch(searchCustodiansRequest());
  api2.get('/api/v2/custodians', {
    method: 'get',
    params: {
      'search[name]': searchBy.name,
      'search[state]': searchBy.state,
      'search[favorite]': searchBy.favourite,
      'search[nearby]': searchBy.nearby,
      'search[longitude]': searchBy.longtitude,
      'search[latitude]': searchBy.latitude,
      'search[city]': searchBy.city,
      'search[fax]': searchBy.fax,
      'search[zipcode]': searchBy.zipcode,
      page: searchBy.page,
      is_form_req: isFormRequest,
    },
  })(dispatch)
    .then(res => {
        dispatch(receiveFoundCustodians(res.custodians, add));
        callback && callback(res)
    })
    .catch(error => dispatch(searchCustodiansFailure(error)));
};

export const searchCustodiansForSuggestions = (searchBy: SearchBy, isFormRequest: boolean, add?: boolean, callback?: (data: any) => void): ThunkResult<void> => async dispatch => {
  api2.get('/api/v2/custodians/get_custodian_suggestion_list', {
    method: 'get',
    params: {
      'search[state]': searchBy.state,
      'search[name]': searchBy.name,
      is_form_req: isFormRequest,
    },
  })(dispatch)
    .then(res => {
        callback && callback(res)
    })
    .catch(error => dispatch(searchCustodiansFailure(error)));
};

export const searchCustodiansByDependentId = (dependentId: string | number, searchBy: SearchBy, isFormRequest: boolean, add?: boolean, callback?: (data: any) => void): ThunkResult<void> => async dispatch => {
  !add && dispatch(searchCustodiansRequest());
  api2.get(`/api/v2/patient/dependents/${dependentId}/custodian_list`, {
    method: 'get',
    params: {
      'search[name]': searchBy.name,
      page: searchBy.page,
    },
  })(dispatch)
    .then(res => {
        dispatch(receiveFoundCustodians(res.custodians, add));
        callback && callback(res)
    })
    .catch(error => dispatch(searchCustodiansFailure(error)));
};

export const getContodianDetails = (searchBy: SearchBy, isFormRequest: boolean, callback?: (custodians: any) => void): ThunkResult<void> => async dispatch => {
  // dispatch(custodianDetailsLoading())
  console.log(searchBy)
  return api2.get('/api/v2/custodians', {
    method: 'get',
    params: {
      'search[name]': searchBy.name,
      'search[state]': searchBy.state,
      'search[favorite]': searchBy.favourite,
      'search[nearby]': searchBy.nearby,
      'search[longitude]': searchBy.longtitude,
      'search[latitude]': searchBy.latitude,
      'search[city]': searchBy.city,
      'search[fax]': searchBy.fax,
      'search[zipcode]': searchBy.zipcode,
      is_form_req: isFormRequest,
    },
  })(dispatch)
    .then(res => {
      if (res.custodians) {
        let custodian = res.custodians.find((item: any) => item.id === searchBy.id)
        if (custodian) {
          dispatch(addCustodian(custodian))
          callback && callback(custodian)
        } else dispatch(custodianDetailsFailure('Custodian not found!'))
      }
    })
    .catch(error => dispatch(custodianDetailsFailure(error.message)));
};

